import { render, staticRenderFns } from "./SessionSummaryTab.vue?vue&type=template&id=478c54e6&scoped=true&"
import script from "./SessionSummaryTab.vue?vue&type=script&lang=js&"
export * from "./SessionSummaryTab.vue?vue&type=script&lang=js&"
import style0 from "./SessionSummaryTab.vue?vue&type=style&index=0&id=478c54e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c54e6",
  null
  
)

export default component.exports